import makeStyles from '@material-ui/styles/makeStyles'

export const useStyles = makeStyles(theme => ({
    formBox: {
        width: 'calc(100vw - 60px)',
        backgroundColor: theme.palette.grey['100'],
        minHeight: theme.spacing(40),
        margin: 'auto',
        paddingBottom: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            width: 'calc(100vw)',
        },
    },
    formTitle: {
        fontSize: theme.spacing(5),
        maxWidth: theme.spacing(129.125),
        width: '90vw',
        margin: 'auto',
        paddingTop: theme.spacing(9),
        [theme.breakpoints.down('sm')]: {
            fontSize: theme.spacing(3),
            paddingTop: theme.spacing(5),
        },
    },
    form: {
        display: 'flex',
        justifyContent: 'space-between',
        margin: 'auto',
        [theme.breakpoints.up('md')]: {
            maxWidth: theme.spacing(129.125),
            width: '90vw',
            flexWrap: 'wrap',
            alignItems: 'flex-end',
        },
        [theme.breakpoints.down('sm')]: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '85vw',
            margin: `0 auto ${theme.spacing(3)}px auto`,
        },
    },
    button: {
        paddingTop: 0,
        marginTop: theme.spacing(3),
        paddingBottom: 0,
        [theme.breakpoints.down('sm')]: {
            display: 'block',
        },
        [theme.breakpoints.up('md')]: {
            maxWidth: theme.spacing(40),
            height: theme.spacing(7),
            fontSize: theme.spacing(2.5),
        },
    },
    input: {
        boxSizing: 'border-box',
        [theme.breakpoints.up('md')]: {
            height: theme.spacing(7),
            width: theme.spacing(26),
        },
        [theme.breakpoints.down('sm')]: {
            width: `calc(100% - ${theme.spacing(17)}px)`,
            maxWidth: '60vw',
            textAlignLast: 'center',
            margin: 0,
            height: theme.spacing(6),
        },
    },
    label: {
        [theme.breakpoints.up('md')]: {
            fontSize: theme.spacing(2),
            paddingLeft: theme.spacing(0.75),
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: theme.spacing(2),
        },
    },
    formRows: {
        [theme.breakpoints.down('sm')]: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            width: '100%',
        },
    },
    transitionOut: {
        opacity: 1,
        display: 'flex',
        justifyContent: 'space-between',
        margin: 'auto',
        animation: `$horizontalMove 2.5s forwards`,
        overflow: 'hidden',
        [theme.breakpoints.up('md')]: {
            maxWidth: theme.spacing(129.125),
            width: '90vw',
            flexWrap: 'wrap',
            alignItems: 'flex-end',
        },
        [theme.breakpoints.down('sm')]: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '85vw',
            margin: `0 auto ${theme.spacing(3)}px auto`,
        },
    },
    '@keyframes horizontalMove': {
        '0%': {
            opacity: 1,
            transform: 'translateX(0px)',
        },

        '100%': {
            opacity: 0,
            transform: 'translateX(40px)',
        },
    },
    transitionIn: {
        display: 'none',
        textAlign: 'center',
        fontSize: theme.spacing(4),
        color: theme.palette.success.main,
        marginBottom: theme.spacing(6),
        marginTop: theme.spacing(5),
    },
    transitionInFailed: {
        display: 'none',
        textAlign: 'center',
        fontSize: theme.spacing(3),
        color: theme.palette.warning.main,
        marginBottom: theme.spacing(6),
        marginTop: theme.spacing(5),
    },
}))
